import React from 'react';

interface TelephoneProps {
    color?: string;
    width?: number;
    height?: number;
    className?: string;
}

const Telephone: React.FC<TelephoneProps> = ({
    color = "#3F3F3F",
    width = 10,
    height = 10,
    className
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 10 10"
            fill="none"
            className={className}
        >
            <path
                d="M9.78707 8.64174C9.97979 8.23774 9.71568 7.79766 9.30394 7.62208L7.7011 6.93856C7.39054 6.80612 7.03412 6.83934 6.75337 7.02688L5.71258 7.72212C5.57541 7.8128 5.41714 7.86649 5.25311 7.87799C5.08908 7.88948 4.92486 7.85838 4.77639 7.78771C3.66544 7.25032 2.7668 6.35588 2.22421 5.24747C2.15267 5.0995 2.12057 4.93556 2.13102 4.77153C2.14146 4.60751 2.19411 4.44897 2.28384 4.31127L2.98434 3.24585C3.16874 2.96537 3.20013 2.61108 3.06791 2.30255L2.37862 0.694218C2.20256 0.28341 1.76305 0.0201248 1.35954 0.212322C1.07003 0.35022 0.808934 0.546195 0.593796 0.790923C0.210724 1.22668 -0.000383221 1.78713 5.22247e-07 2.36732C0.00157979 4.39115 0.806242 6.33163 2.2373 7.7627C3.66837 9.19376 5.60885 9.99842 7.63268 10C8.21287 10.0004 8.77332 9.78928 9.20908 9.4062C9.45344 9.19138 9.6492 8.93074 9.78707 8.64174Z"
                fill={color}
            />
        </svg>
    );
};

export default Telephone;
